import { Action } from '@ngrx/store';
import {
  MFAOutcome,
  OneTimeRedemptionPointsTransfer,
} from '@rd/core//mfa/types';
import { HttpError, PointsTransaction } from '@rd/types';
import { Promocode, PromocodeUsage } from '@rd/types/promocode.type';
import { TransferConnectV2CheckoutFormData } from '../../types';

export enum CheckoutActionTypes {
  CLEAR_CHECKOUT_FORM_DATA = '[TransferConnectV2] Clear Checkout Form Data',
  CLEAR_POINTS_TRANSFER_ERROR = '[TransferConnectV2] Clear Points Transfer Error',
  SUBMIT_CHECKOUT_FORM_DATA = '[TransferConnectV2] Submit Checkout Form Data',
  SUBMIT_POINTS_TRANSFER = '[TransferConnectV2] Submit Points Transfer',
  SUBMIT_POINTS_TRANSFER_SUCCESS = '[TransferConnectV2] Submit Points Transfer Success',
  SUBMIT_POINTS_TRANSFER_FAIL = '[TransferConnectV2] Submit Points Transfer Fail',
  HYDRATE_POINTS_TRANSFER_REDEMPTION = '[TransferConnectV2] Hydrate Points Transfer Redemption',
}

export class ClearCheckoutFormData implements Action {
  readonly type = CheckoutActionTypes.CLEAR_CHECKOUT_FORM_DATA;

  constructor(public payload: { loyaltyProgramId: string }) {}
}

export class ClearPointsTransferError implements Action {
  readonly type = CheckoutActionTypes.CLEAR_POINTS_TRANSFER_ERROR;

  constructor() {}
}

export class SubmitCheckoutFormData implements Action {
  readonly type = CheckoutActionTypes.SUBMIT_CHECKOUT_FORM_DATA;

  constructor(
    public payload: {
      loyaltyProgramId: string;
      formData: TransferConnectV2CheckoutFormData;
    },
  ) {}
}

export class SubmitPointsTransfer implements Action {
  readonly type = CheckoutActionTypes.SUBMIT_POINTS_TRANSFER;

  constructor(
    public payload: {
      loyaltyProgramId: string;
      formData: TransferConnectV2CheckoutFormData;
      promocode?: Promocode;
      // This property only for restoring promocode state
      // when we redirect from MFA
      promocodeUsage?: PromocodeUsage;
    },
  ) {}
}

export class SubmitPointsTransferSuccess implements Action {
  readonly type = CheckoutActionTypes.SUBMIT_POINTS_TRANSFER_SUCCESS;

  constructor(public payload: PointsTransaction) {}
}

export class SubmitPointsTransferFail implements Action {
  readonly type = CheckoutActionTypes.SUBMIT_POINTS_TRANSFER_FAIL;

  constructor(public payload: HttpError) {}
}

export class HydratePointsTransferRedemption implements Action {
  readonly type = CheckoutActionTypes.HYDRATE_POINTS_TRANSFER_REDEMPTION;

  constructor(
    public payload: {
      pointsTransferHydrationState: OneTimeRedemptionPointsTransfer;
      outcome: MFAOutcome;
    },
  ) {}
}

export type CheckoutActions =
  | ClearCheckoutFormData
  | ClearPointsTransferError
  | SubmitCheckoutFormData
  | SubmitPointsTransfer
  | SubmitPointsTransferSuccess
  | SubmitPointsTransferFail
  | HydratePointsTransferRedemption;
